/**
 * @generated SignedSource<<fde0a13daec520793167038eaa94e438>>
 * @relayHash 25b8cff1806cf3e404078112e461d347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3af4a663fc421445f64d17edbd745c72fa74edb1f52c0e15cbe1810e01a9f1d8

import type { ConcreteRequest } from 'relay-runtime';
export type useLabelsSelectPropsDeleteLabelMutation$variables = {
  contentId: string;
  label: string;
};
export type useLabelsSelectPropsDeleteLabelMutation$data = {
  readonly deleteLabel: {
    readonly contentId: string;
    readonly label: string;
  } | null;
};
export type useLabelsSelectPropsDeleteLabelMutation = {
  response: useLabelsSelectPropsDeleteLabelMutation$data;
  variables: useLabelsSelectPropsDeleteLabelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "label"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "label",
            "variableName": "label"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "DeleteLabelPayload",
    "kind": "LinkedField",
    "name": "deleteLabel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "label"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelsSelectPropsDeleteLabelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelsSelectPropsDeleteLabelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25b8cff1806cf3e404078112e461d347",
    "id": "3af4a663fc421445f64d17edbd745c72fa74edb1f52c0e15cbe1810e01a9f1d8",
    "metadata": {},
    "name": "useLabelsSelectPropsDeleteLabelMutation",
    "operationKind": "mutation",
    "text": "mutation useLabelsSelectPropsDeleteLabelMutation($contentId:ID!,$label:String!){deleteLabel(input:{contentId:$contentId,label:$label}){contentId,label}}"
  }
};
})();

(node as any).hash = "8abc9b6dbe557f1c15195bda640c444e";

export default node;
